module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    attrs: {
      "id": "row center-block"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-12"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "displayName"
    }
  }, [(_vm.flag === 'es') ? _c('span', [_vm._v("Nombre de usuario")]) : (_vm.flag === 'de') ? _c('span', [_vm._v("Benutzername")]) : (_vm.flag === 'us') ? _c('span', [_vm._v("Username")]) : _c('span', [_vm._v("Nome do Usuário")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.displayNameNew),
      expression: "displayNameNew"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "displayName"
    },
    domProps: {
      "value": (_vm.displayNameNew)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.displayNameNew = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        _vm.alterarNomeUsuario()
      }
    }
  }, [(_vm.flag === 'es') ? _c('span', [_vm._v("Registro")]) : (_vm.flag === 'de') ? _c('span', [_vm._v("Aufnehmen")]) : (_vm.flag === 'us') ? _c('span', [_vm._v("Save")]) : _c('span', [_vm._v("Gravar")])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body col-md-12"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "buttom"
    },
    on: {
      "click": function($event) {
        _vm.alterarSenhaUsuario()
      }
    }
  }, [(_vm.flag === 'es') ? _c('span', [_vm._v("Restablecer contraseña")]) : (_vm.flag === 'de') ? _c('span', [_vm._v("Passwort zurücksetzen")]) : (_vm.flag === 'us') ? _c('span', [_vm._v("Redefine password")]) : _c('span', [_vm._v("Redefinir Senha")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix visible-sm-block"
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-449577a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Usuario.vue
// module id = 338
// module chunks = 1